

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  "http://localhost:8000";

// Basic headers for standard GET requests 
const getHeaders = () => {
  const token = localStorage.getItem("token");

  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};

// Specialized header generator for file uploads/FormData
const getMultipartHeaders = () => {
  const token = localStorage.getItem("token");

  return {
    // CRITICAL: We do NOT define "Content-Type" here.
    // Leaving it out allows the browser to automatically format it as:
    // multipart/form-data; boundary=----WebKitFormBoundary...
    Authorization: `Bearer ${token}`,
  };
};

/* --------------------------
   GET MESSAGE TEMPLATES
-------------------------- */
export const getMessageTemplates = async () => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/msg_templates/`,
      {
        method: "GET",
        headers: getHeaders(),
      }
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(
        data.error || "Failed to fetch templates"
      );
    }

    return data;
  } catch (error) {
    console.error("Message templates error:", error);
    throw error;
  }
};

/* --------------------------
   GET DESIGN TEMPLATES
-------------------------- */
export const getDesignTemplates = async (templateId) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/design_templates/${templateId}/`,
      {
        method: "GET",
        headers: getHeaders(),
      }
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(
        data.error || "Failed to fetch design templates"
      );
    }

    return data;
  } catch (error) {
    console.error("Design template error:", error);
    throw error;
  }
};

/* --------------------------
   SUBMIT PROJECT REQUEST
-------------------------- */
export const submitProjectRequest = async (payload) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/submit_request/`,
      {
        method: "POST",
        // Swapped to our multipart configuration helper to safely carry your brand logo image
        headers: getMultipartHeaders(), 
        // Removed JSON.stringify() because payload is already a raw FormData object 
        body: payload, 
      }
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(
        data.error || "Failed to submit request"
      );
    }

    return data;
  } catch (error) {
    console.error("Submit request error:", error);
    throw error;
  }
};